// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3793":"ba877205","5092":"ae8ad23a"}[chunkId] + ".chunk.css";
};